export default __webpack_public_path__ + "static/media/Template-10.f39afa6c.doc";